import { authClient } from "@/api/http-client"
import { IPaginatedCollection, IPaginationRequest } from "@/api/types"
import {IConfirmBody, IRefundMoneyRequest, IRejectBody, IResendNotificationBody} from "@/types/refundMoneyRequest"

export function fetchAll(pagination: IPaginationRequest): Promise<IPaginatedCollection<IRefundMoneyRequest>> {
  return authClient
    .get<IPaginatedCollection<IRefundMoneyRequest>>(`refund-money-request`, {
      params: { ...pagination }
    })
    .then((resp) => resp.data)
}

export function fetch(id: string): Promise<IRefundMoneyRequest> {
  return authClient
    .get<IRefundMoneyRequest>(`refund-money-request/${id}`)
    .then((resp) => resp.data)
}

export function reject(body: IRejectBody): Promise<void> {
  return authClient
    .post<void>(`refund-money-request/reject`, body)
    .then((resp) => resp.data)
}

export function confirm(body: IConfirmBody): Promise<void> {
  return authClient
    .post<void>(`refund-money-request/confirm`, body)
    .then((resp) => resp.data)
}

export function resendNotification(body: IResendNotificationBody): Promise<void> {
  return authClient
    .post<void>(`refund-money-request/resend-notification`, body)
    .then((resp) => resp.data)
}

export default {
  fetchAll,
  fetch,
  confirm,
  reject,
  resendNotification
}